import { TextAreaTemplate } from '@templates';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { RoutesList } from '@cycle-hangars/routes/Routes';
import { useCycleStore } from '@cycle-hangars/store/store';
import { ErrorMessages } from '@types';
import { parseZodErrors, scrollTop, textAreaInputSchema } from '@utils';
import { ZodError } from 'zod';

export const AbandonedProvideDescription = () => {
  const { updateDescribeBikeText, describeBikeText } = useCycleStore();
  const [textInput, setTextInput] = useState(describeBikeText);
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const navigate = useNavigate();
  const MAX_LENGTH = 500;
  const pageTitle = 'Provide a description of the bike ';
  const errorPath = 'abandonedProvideDescription';
  const description = 'For example, the make, model and colour.';

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextInput(event.target.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      try {
        const validatedData = textAreaInputSchema({
          fieldName: errorPath,
          requiredMessage: 'Enter a description of the bike.',
          maxLength: MAX_LENGTH,
          maxLengthMessage: `The description of the bike must be 500 characters or less.`,
        }).parse({
          [errorPath]: textInput,
        });
        if (validatedData[errorPath]) {
          updateDescribeBikeText(validatedData[errorPath]);
        }
        navigate(RoutesList.TELL_US_MORE);
        scrollTop();
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.ABANDONED_OR_UNAUTHORISED);
      scrollTop();
    },
  };

  return (
    <TextAreaTemplate
      initialTextValue={textInput}
      labelText={pageTitle}
      description={description}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
      maxLength={MAX_LENGTH}
      errorPath={errorPath}
      errorMessages={errorMessages}
    />
  );
};
